import mixins from 'synergycms_core/src/less/mixins';

export default {
  tooltipStyle: {
    display: 'flex',
    zIndex: '900',
    position: 'absolute'
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    fontSize: '13px',
    zIndex: '800',
    color: data => data.mainColor,
    fontWeight: 'bold',
    '&:lang(ar)':{
      left:'7px',
      right:'auto',
      top:'7px',
    }
  },
  popoverTransitionEnter: {
    ...mixins.opacity(0.01)
  },
  popoverTransitionEnterActive: {
    ...mixins.opacity(1),
    transition: 'opacity 500ms ease-in'
  },
  popoverTransitionLeave: {
    ...mixins.opacity(1)
  },
  popoverTransitionLeaveActive: {
    ...mixins.opacity(0.01),
    ...mixins.transition('opacity 500ms ease-in')
  }
};
